// StopTimerDialog.js - Dialog nach Timer-Stopp mit festen Feldern
import React, { useState } from 'react';
import LoadingSpinner from '../common/LoadingSpinner';
import Dialog from '../common/Dialog';

const StopTimerDialog = ({ isOpen, onClose, onSave, initialData, tasks, isLoading }) => {
  const [activity, setActivity] = useState(initialData?.activity || '');

  // Start- und Endzeit werden nicht editierbar angezeigt
  const startTime = initialData?.startTime || '';
  const endTime = initialData?.endTime || '';
  const date = initialData?.date || '';

  const handleSave = () => {
    onSave({
      date,
      startTime,
      endTime,
      activity,
    });
  };

  return (
    <Dialog
      isOpen={isOpen}
      onClose={onClose}
      title="Zeiteintrag nach Timer-Stopp"
      size="sm"
      actions={[
        <button
          key="save"
          className="bg-primary text-white px-4 py-2 rounded hover:bg-primaryDark"
          onClick={handleSave}
          disabled={isLoading || !activity}
        >
          Speichern
        </button>,
        <button
          key="cancel"
          className="ml-2 bg-gray-200 text-gray-800 px-4 py-2 rounded hover:bg-gray-300"
          onClick={onClose}
          disabled={isLoading}
        >
          Abbrechen
        </button>
      ]}
    >
      <div className="relative">
        {/* Overlay Spinner bei isLoading */}
        {isLoading && (
          <div className="absolute inset-0 bg-white bg-opacity-70 flex items-center justify-center z-20 rounded">
            <LoadingSpinner height={48} width={48} containerClassName="" />
          </div>
        )}
        <div className={`space-y-4 ${isLoading ? 'opacity-50 pointer-events-none select-none' : ''}`}>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Datum</label>
            <input type="date" value={date} disabled className="w-full border rounded px-3 py-2 bg-gray-100" />
          </div>
          <div className="flex space-x-2">
            <div className="flex-1">
              <label className="block text-sm font-medium text-gray-700 mb-1">Startzeit</label>
              <input type="time" value={startTime} disabled className="w-full border rounded px-3 py-2 bg-gray-100" />
            </div>
            <div className="flex-1">
              <label className="block text-sm font-medium text-gray-700 mb-1">Endzeit</label>
              <input type="time" value={endTime} disabled className="w-full border rounded px-3 py-2 bg-gray-100" />
            </div>
          </div>
          {/* <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Kunde</label>
            <input type="text" value="Wollino" disabled className="w-full border rounded px-3 py-2 bg-gray-100" />
          </div> */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Standort</label>
            <input type="text" value="Zentrale" disabled className="w-full border rounded px-3 py-2 bg-gray-100" />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Tätigkeit</label>
            <select
              value={activity}
              onChange={e => setActivity(e.target.value)}
              className="w-full border rounded px-3 py-2"
              required
            >
              <option value="">Tätigkeit auswählen</option>
              {tasks && tasks.map(task => (
                <option key={task._id} value={task._id}>{task.name}</option>
              ))}
            </select>
          </div>
        </div>
      </div>
    </Dialog>
  );
};

export default StopTimerDialog;